import { getTraceContext, newSpanId } from './traceContext';
import { DATA_ADAPTER } from '../../config/adapters';

const buffer: Record<string, unknown>[] = [];

export async function logAuditEvent(partial: Record<string, unknown>): Promise<Record<string, unknown>> {
  const { traceId, requestId } = getTraceContext();
  const entry = {
    traceId,
    spanId: partial.spanId ?? newSpanId(String(partial.action ?? 'event')),
    requestId,
    source: partial.source ?? 'client',
    ...partial,
  };

  buffer.push(entry);
  if (buffer.length > 100) buffer.shift();

  if (DATA_ADAPTER !== 'firebase') return entry;

  try {
    const { callFunction } = await import('../firebase/FunctionsService.js');
    await callFunction('writeAuditEvent', entry);
  } catch (err) {
    console.warn('[Audit] writeAuditEvent failed:', err);
  }

  return entry;
}
